import { render, staticRenderFns } from "./RefundProductDetails.vue?vue&type=template&id=5ca2fb58&"
import script from "./RefundProductDetails.vue?vue&type=script&lang=js&"
export * from "./RefundProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports